import { useEffect, useState } from "react";

const KEY = "ch_recent";
const MAX = 6;

export interface RecentItem {
  slug: string;
  title: string;
  categoryName: string;
  categorySlug: string;
}

function readStorage(): RecentItem[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as RecentItem[]) : [];
  } catch {
    return [];
  }
}

export function trackView(item: RecentItem) {
  try {
    const prev = readStorage();
    const next = [item, ...prev.filter((r) => r.slug !== item.slug)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch { /* ignore */ }
}

export function useRecentlyViewed() {
  const [recent, setRecent] = useState<RecentItem[]>([]);
  useEffect(() => {
    setRecent(readStorage());
  }, []);
  return recent;
}
